import React from 'react'
import './Loader.css'
const Loader = ({height}) => {
  return (
    <div className='loaderContainer' style={{height: height}}>
        <div className="loader"></div>
    </div>
  )
}

export default Loader